import { render } from "./InvestmentsWithRussia.vue?vue&type=template&id=15532319&scoped=true"
import script from "./InvestmentsWithRussia.vue?vue&type=script&lang=js"
export * from "./InvestmentsWithRussia.vue?vue&type=script&lang=js"

import "./InvestmentsWithRussia.vue?vue&type=style&index=0&id=15532319&scoped=true&lang=scss"
import "./InvestmentsWithRussia.vue?vue&type=style&index=1&id=15532319&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15532319"]])

export default __exports__